<template>
  <div class="lottie-player__body"></div>
</template>

<script>
import lottieWeb from "lottie-web";
import delayFunc from "@/utils/delay";

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.play(this.url, { delay: 0 });
  },
  methods: {
    async play(url, options = { delay: 0 }) {
      lottieWeb.destroy();

      const { delay, duration } = options;

      this.$el.querySelectorAll(".lottie__wrapper").forEach((el) => {
        this.$el.removeChild(el);
      });

      // create child el
      const el = document.createElement("div");
      el.classList.add("lottie__wrapper");
      el.style.width = "100%";
      el.style.height = "100%";
      this.$el.appendChild(el);

      await delayFunc(delay);
      this.animation = lottieWeb.loadAnimation({
        container: el,
        renderer: "svg",
        loop: true,
        autoplay: true,
        // path: `/lotties/${lottieId}`,
        path: url,
      });

      try {
      } catch (error) {}
    },
    stop() {
      this.$el.querySelectorAll(".lottie__wrapper").forEach((el) => {
        this.$el.removeChild(el);
      });
    },
  },
  destroyed() {},
};
</script>

<style scoped>
.lottie-player__body {
  width: 100%;
  height: 100%;
}
</style>
